import React from "react";
import { useTranslation } from "react-i18next";
import { Radio, Segment } from "semantic-ui-react";
import parse from "html-react-parser";

interface Props {
  questionHeading: string;
  invalid: boolean;
  valueText: string | null | undefined;
  value: number | null;
  onValueChange: (value: number, text: string) => void;
}

export default function YesNoControl({
  questionHeading,
  onValueChange,
  invalid,
  value,
  valueText,
}: Props) {
  const { t } = useTranslation("common");
  const changeValue = (newValue: number, text: string) => {
    onValueChange(newValue, text);
  };
  return (
    <>
      <div className={invalid ? "negative-message" : "question-wrapper"}>
        <label className="statement">{parse(questionHeading)}</label>
        <Segment className="survey-answers feedradiocheck">
          <Radio
            checked={value === 1}
            onChange={() => {
              changeValue(1, "No");
            }}
            label={t("YesNoControl.No")}
          />
          <Radio
            checked={value === 2}
            onChange={() => {
              changeValue(2, "Yes");
            }}
            label={t("YesNoControl.Yes")}
          />
          {value === 2 && (
            <>
              {t("Feedback.Q5Sub")}
              <textarea
                name="Text1"
                value={!valueText || valueText === "Yes" ? "" : valueText}
                rows={3}
                cols={40}
                onChange={(e) => {
                  changeValue(2, e.target.value);
                }}
              />
            </>
          )}
        </Segment>
      </div>
    </>
  );
}
